module.exports = __webpack_public_path__ + "img/batchEditCollectors.a6cbcae6.png";